import { render } from "./BlockBuilder.vue?vue&type=template&id=69d89e88&scoped=true"
import script from "./BlockBuilder.vue?vue&type=script&lang=js"
export * from "./BlockBuilder.vue?vue&type=script&lang=js"

import "./BlockBuilder.vue?vue&type=style&index=0&id=69d89e88&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d89e88"]])

export default __exports__